import { useEffect } from 'react';

import {
  useFullOnlyFirstFreeshipping,
  setFullOnlyFirstFreeshipping,
} from '../../../components/context/full-freeshipping';

const useFullSnackbarState = (progressBar) => {
  const fullOnlyFirstFreeshipping = useFullOnlyFirstFreeshipping();
  const success = progressBar?.color === 'success';
  const warning = progressBar?.color === 'warning';

  useEffect(() => {
    if (fullOnlyFirstFreeshipping) {
      setFullOnlyFirstFreeshipping(
        (success && fullOnlyFirstFreeshipping.successFirst) || (warning && fullOnlyFirstFreeshipping.warningFirst),
      );
    }

    return () => {
      if (success || warning) {
        setFullOnlyFirstFreeshipping({ successFirst: success, warningFirst: warning });
      }
    };
  }, [progressBar, fullOnlyFirstFreeshipping, success, warning]);

  return {
    fullOnlyFirstFreeshipping,
    success,
    warning,
  };
};

export default useFullSnackbarState;
